import { fromJS } from "immutable";

import TYPE from "../../constants/type";

// [VinUni] Module 8 - Quản lý văn bản
const initialState = fromJS({
  list: [],
  isFetching: false,
  isSubmitting: false,
});

export default function documentReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.DOCUMENT.GET_ALL_DOCUMENT_LOADING:
    case TYPE.DOCUMENT.GET_DOCUMENT_BY_DEPARTMENT_LOADING:
      return state.merge({ isFetching: true });

    case TYPE.DOCUMENT.GET_ALL_DOCUMENT_FAILURE:
    case TYPE.DOCUMENT.GET_DOCUMENT_BY_DEPARTMENT_FAILURE:
      return state.merge({ isFetching: false });

    case TYPE.DOCUMENT.GET_ALL_DOCUMENT_SUCCESS:
    case TYPE.DOCUMENT.GET_DOCUMENT_BY_DEPARTMENT_SUCCESS:
      return state.merge({ list: action.payload ?? [], isFetching: false });

    case TYPE.DOCUMENT.INSERT_DOCUMENT_LOADING:
    case TYPE.DOCUMENT.UPDATE_DOCUMENT_LOADING:
    case TYPE.DOCUMENT.DELETE_DOCUMENT_LOADING:
      return state.merge({ isSubmitting: true });

    case TYPE.DOCUMENT.INSERT_DOCUMENT_FAILURE:
    case TYPE.DOCUMENT.UPDATE_DOCUMENT_FAILURE:
    case TYPE.DOCUMENT.DELETE_DOCUMENT_FAILURE:
    case TYPE.DOCUMENT.INSERT_DOCUMENT_SUCCESS:
    case TYPE.DOCUMENT.UPDATE_DOCUMENT_SUCCESS:
    case TYPE.DOCUMENT.DELETE_DOCUMENT_SUCCESS:
      return state.merge({ isSubmitting: false });

    default:
      return state;
  }
}
